import appApi from '../../../../../api/app-api';
import { toast } from 'react-toastify';
import { UserSummaryType } from '../../../../../api/types/user/user-summary.type';
import { UserType } from '../../../../../api/types/user/user-type';
import globalUserPage from '../../../../../stores/global-user-page';
import { DocDetails } from '../../../../../api/types/docs/doc-details';

export const addNewDocOperations = async (
  userId: number,
  user: UserSummaryType,
  docName: string,
  description: string,
  docTypeId: number,
  onHide: () => any,
  branchId: number | null,
  programId: number | null,
  updateState: boolean,
  setLoading: (loading: boolean) => any,
) => {
  try {
    if (docName.length < 3 || description.length < 3 || !docTypeId) {
      toast.warn('יש להזין שם מסמך, תיאור וסוג מסמך תקינים');
      return;
    }
    setLoading(true);
    const res = await appApi.addNewDoc(
      userId,
      docName,
      description,
      docTypeId,
      branchId,
      programId,
    );

    const docDetails: DocDetails = {
      docMetadata: res.data.body,
      feedbacks: [],
    };
    /*toast.error(`${JSON.stringify(globalUserPage.studentDetails)}`);
    toast.error(`${JSON.stringify(globalUserPage.lecturerDetails)}`);
    toast.error(`${JSON.stringify(globalUserPage.lecturerDetails.docs)}`);*/
    if (updateState) {
      if (user.role === UserType.STUDENT) {
        globalUserPage.studentDetails.docs.push(docDetails);
      } else if (user.role === UserType.LECTURER) {
        if (globalUserPage.lecturerDetails.docs === undefined) {
          globalUserPage.lecturerDetails.docs = [docDetails];
        } else {
          globalUserPage.lecturerDetails.docs.push(docDetails);
        }
      }
    }

    // Update the state
    if (user.role === UserType.STUDENT) {
      const updatedUserDetails = await appApi.getUserStudentDetails(user.id);
      globalUserPage.studentDetails = updatedUserDetails.data.body;
    } else if (user.role === UserType.LECTURER) {
      const updatedUserDetails = await appApi.getUserLecturerDetails(user.id);
      globalUserPage.lecturerDetails = updatedUserDetails.data.body;
    }
    setLoading(false);
    onHide();
    toast.success('יצירת המסמך התבצעה בהצלחה');
  } catch (e) {
    setLoading(false);
    toast.error('יצירת המסמך נכשלה, נסה שוב בעוד מספר רגעים...');
    console.error(`add new doc is failed with th error: ${e}`);
  }
};
